import { accessRole } from "../../../helpers/access_role"
import ErrorAccess from '../../../components/Error/Content/Access'

import IndexView from "./Index/View"
// import CreateView from "./Create/View"
// import DetailView from "./Detail/View"
// import UpdateView from "./Update/View"
// import ChartView from "./Charts/View"
import DraftView from "./Draft/View"

const RouteView = (props) => {

  const queryParams = new URLSearchParams(props.location.search);
  const _uuid = queryParams.get('uuid');
  const _period = queryParams.get('period');
  const _create = queryParams.get('create')
  const _detail = queryParams.get('detail')
  const _update = queryParams.get('update')
  const _charts = queryParams.get('charts')
  const _draft = queryParams.get('draft')
  const _delete = queryParams.get('detail')
  const _approve = queryParams.get('approve')
  const _print = queryParams.get('print')

  if (_create != null) {
    // return accessRole('create') ? <CreateView /> : <ErrorAccess />
  } else if (_detail != null) {
    // return accessRole('read') ? <DetailView uuid={_uuid} /> : <ErrorAccess />
  } else if (_update != null) {
    // return accessRole('update') ? <UpdateView uuid={_uuid} /> : <ErrorAccess />
  } else if (_charts != null) {
    // return accessRole('read') ? <ChartView uuid={_uuid} period={_period} /> : <ErrorAccess />
  } else if (_draft != null) {
    return accessRole('approve') ? <DraftView /> : <ErrorAccess />
  } // else if (_delete != null) {
//     return null
//   } else if (_approve != null) {
//     return null
//   } else if (_print != null) {
//     return null
//   }
  return accessRole('read') ? <IndexView /> : <ErrorAccess />
}
export default RouteView
